import {
  BarSeries,
  ChartComponent,
  ColumnSeries,
  DateTime,
  Inject,
  LineSeries,
  SeriesCollectionDirective,
  SeriesDirective,
  StripLine,
  Zoom,
} from "@syncfusion/ej2-react-charts";
import React from "react";

const SpeedGraph = ({ data, index }) => {
  return (
    <div className="h-full">
      <ChartComponent
        primaryXAxis={{
          valueType: "DateTime",
          majorGridLines: { width: 0 },
          minorGridLines: { width: 0 },
          labelFormat: "hh:mm a",
          labelIntersectAction: "Hide",
          labelStyle: { size: "10px", color: "white" },
        }}
        primaryYAxis={{
          majorGridLines: { width: 0 },
          minorGridLines: { width: 0 },
          labelStyle: { size: "10px", color: "white", fontFamily: "Roboto" },
          stripLines: [
            {
              start: 85,
              end: 86,
              text: "",
              color: "red",
              visible: true,
            },
            {
              start: 48,
              end: 49,
              text: "",
              color: "orange",
              opacity: 0.5,
              visible: true,
            },
            {
              start: 20,
              end: 21,
              text: "",
              color: "skyblue",
              opacity: 0.5,
              visible: true,
            },
          ],
        }}
        className="bg-black"
        zoomSettings={{
          enablePan: true,
          enableSelectionZooming: true,
          mode: "X",
        }}
        id={index}
      >
        <Inject
          services={[
            LineSeries,
            DateTime,
            Zoom,
            BarSeries,
            ColumnSeries,
            StripLine,
          ]}
        />
        <SeriesCollectionDirective>
          <SeriesDirective
            dataSource={data}
            xName="x"
            yName="y"
            width={2}
            type={"Line"}
            marker={{ visible: true }}
          ></SeriesDirective>
        </SeriesCollectionDirective>
      </ChartComponent>
    </div>
  );
};

export default SpeedGraph;
